import { useEffect, useMemo, useState } from "react";

import { type ViewColumnDef } from "@moment/api-collab/api-types";

import { type BaseViewHandle } from "../BaseViewHandle";
import { existingAccessorKeys, headerToAccessorKey } from "../columnUtil";

export const useRenameColumnState = (
	viewHandle: BaseViewHandle,
	column: ViewColumnDef | undefined
) => {
	const accessorKey = column?.accessorKey.replace(/^\$\./, "");
	const currentHeaderValue = column?.header ?? accessorKey;
	const [internalHeaderValue, setInternalHeaderValue] = useState(column?.header ?? accessorKey);
	useEffect(() => {
		setInternalHeaderValue(column?.header ?? accessorKey);
	}, [accessorKey, column?.header]);
	const headerChanged = internalHeaderValue?.trim() !== currentHeaderValue?.trim();

	const newAccessorKey = useMemo(() => {
		if (!internalHeaderValue || !headerChanged) {
			return undefined;
		}
		return headerToAccessorKey(
			internalHeaderValue,
			existingAccessorKeys(viewHandle.columnDefs)
		);
	}, [internalHeaderValue, headerChanged, viewHandle.columnDefs]);

	return {
		currentHeaderValue,
		internalHeaderValue,
		setInternalHeaderValue,
		headerChanged,
		newAccessorKey,
	};
};
